module.exports = __webpack_public_path__ + "assets/bunny-40x40.7e0856e598081237e6a06ec992a38da8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./imgs/bunny-40x40.png
 ** module id = 181
 ** module chunks = 0
 **/